import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import RoleAddChild from "./RoleAddChild";
import CardBackground from "../../../components/MainTemplate/CardBackground";

const RoleAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <RoleAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default RoleAdd;
